import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import HttpApi from "i18next-http-backend"; // For translation files via HTTP
import LanguageDetector from "i18next-browser-languagedetector"; // For language detection

// Initialize i18next
i18n
  .use(HttpApi) // Load translation files via HTTP
  .use(LanguageDetector) // Automatically detect user language
  .use(initReactI18next) // Passes i18n to react-i18next
  .init({
    fallbackLng: "en", // Fallback language if no match is found
    debug: true, // Enable debugging in development mode
    supportedLngs: ["en", "ta", "hi"], // Add Tamil and Hindi
    backend: {
      loadPath: "/locales/{{lng}}/translation.json", // Translation files path
    },
    interpolation: {
      escapeValue: false, // React already escapes values
    },
  });

export default i18n;
